import { render, staticRenderFns } from "./MxConnectWidget.vue?vue&type=template&id=17fc8a04&scoped=true&"
import script from "./MxConnectWidget.vue?vue&type=script&lang=js&"
export * from "./MxConnectWidget.vue?vue&type=script&lang=js&"
import style0 from "./MxConnectWidget.vue?vue&type=style&index=0&id=17fc8a04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc8a04",
  null
  
)

export default component.exports